"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.faq), { lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1 })); };
var mapDispatchToProps = function (dispatch) { return ({}); };
var faq = function (props) {
    var t = props.t;
    var rows = [
        [t.q1, t.a1],
        [t.q2, t.a2],
        [t.q3, t.a3],
        [t.q4, t.a4],
        [t.q5, t.a5],
        [t.q6, t.a6],
        [t.q7, t.a7],
        [t.q8, t.a8],
        [t.q9, t.a9],
        [t.q10, t.a10],
    ];
    var renderRow = (function (it) { return (React.createElement("div", { className: "c-faq__item c-faq__item--expand", style: { cursor: 'pointer' } },
        React.createElement("div", { className: "c-faq__question", dangerouslySetInnerHTML: { __html: it[0] } }),
        React.createElement("div", { className: "c-faq__answer" },
            React.createElement("div", { className: "c-faq__answer-text", dangerouslySetInnerHTML: { __html: it[1] } })))); });
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { className: "g-reset l-container l-container--lr" },
            React.createElement("div", { className: "l-container__main l-pad-top" },
                React.createElement("div", { className: "c-page-header c-page-header--center c-page-header--center-mobile" },
                    React.createElement("div", { className: "c-page-header__title" }, props.t.title)),
                React.createElement("div", { className: "c-accountfaq" },
                    React.createElement("div", { className: "c-faq__body" }, rows.map(renderRow)))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(faq);
